export const MATH_SYMBOLS = [
  {
    isSymbol: true,
    symbol: '+',
    icon: 'plus',
    calculate: (result, newValue) => (result += Number(newValue)),
  },
  {
    isSymbol: true,
    symbol: '-',
    icon: 'minus',
    calculate: (result, newValue) => (result -= Number(newValue)),
  },
  {
    isSymbol: true,
    symbol: '×',
    icon: 'x',
    calculate: (result, newValue) => (result *= Number(newValue)),
  },
  {
    isSymbol: true,
    symbol: '÷',
    icon: 'divide',
    calculate: (result, newValue) => (result /= Number(newValue)),
  },
]
